import React, { useState } from "react";
import "./FAQ.css";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";
import useAndroidBridge from "../../hooks/useAndroidBridge";

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [openItem, setOpenItem] = useState<number | null>(null);
  const { isEmbed } = useMembership();
  const { sendToAndroid } = useAndroidBridge();
  const faqItems: FAQItem[] = [
    {
      id: 1,
      question: "AI가 내 이야기를 정말 이해할까?",
      answer:
        "시니어 어르신들만을 위해 특별히 만들어진 친구예요. 5,000명 이상의 시니어 인터뷰를 학습해서 마치 손자와 이야기하는 것처럼 편안합니다.",
    },
    {
      id: 2,
      question: "사투리도 알아들을까?",
      answer:
        "전국 방언을 완벽하게 학습했어요. 오히려 사투리 표현을 살려서 더 정감 있는 책이 나와요. 느린 말도 전혀 문제없습니다.",
    },
    {
      id: 3,
      question: "개인적인 이야기가 안전할까?",
      answer:
        "은행급 보안 시스템으로 완벽 보호합니다. 서비스 완료 후 음성 데이터는 완전 삭제되며, 오직 당신만이 열쇠를 가지고 있어요.",
    },
    {
      id: 4,
      question: "비용이 부담스럽지 않을까?",
      answer:
        "하루 커피 한 잔 값으로 평생의 보물을 만들 수 있어요. 월 10만원대부터 시작하며, 분할결제도 가능합니다.",
    },
    {
      id: 5,
      question: "디지털 기기 사용이 어려우면?",
      answer:
        "그냥 말씀만 하시면 돼요! 복잡한 조작은 전혀 없고, 전화 인터뷰도 가능합니다. 24시간 전화 지원으로 언제든 도와드려요.",
    },
    {
      id: 6,
      question: "내 평범한 이야기가 책이 될까?",
      answer:
        "평범한 일상이야말로 가장 소중하고 특별한 이야기예요. 당신의 이야기는 가족에게 그 무엇보다 소중한 보물입니다.",
    },
  ];

  const handleQuestionClick = (id: number) => {
    setOpenItem(openItem === id ? null : id);
  };

  return (
    <>
      {isEmbed() && (
        <div className={`mobile_app_header`}>
          <button
            onClick={() => sendToAndroid("go-to-page", "")}
            className={`btn btn_back`}
          ></button>
          {/* <p className={`mobile_app_header_text`}>1:1문의</p> */}
        </div>
      )}
      <section id="concerns" className="concerns-section">
        <div className="concerns-container">
          <div className="section-header">
            <div className="section-meta section-meta--orange">
              자주 묻는 질문
            </div>
            <h2 className="section-title">혹시 이런 걱정 하고 계시나요?</h2>
            <p className="section-subtitle">
              기억의 서랍이 모든 걱정을 해소해드립니다.
            </p>
          </div>
          <div className="faq-list">
            {faqItems.map((item) => (
              <div
                key={item.id}
                className={`faq-item ${openItem === item.id ? "open" : ""}`}
              >
                <button
                  className="faq-question"
                  onClick={() => handleQuestionClick(item.id)}
                  aria-expanded={openItem === item.id}
                >
                  <span>{item.question}</span>
                  <span className="faq-toggle">
                    {openItem === item.id ? "−" : "+"}
                  </span>
                </button>
                <div className="faq-answer">{item.answer}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQ;
